<template>
  <div>
    <!--  Summary
    -------------------------------------------------- -->
    <template v-if="isSummary">
      <div class="columns">
        <div class="column">
          <summary-item :amount="sellingInfo.sale_amount">Sale Amount</summary-item>
        </div>
        <div class="column">
          <summary-item :amount="record.actual_profit">Actual Profit</summary-item>
        </div>
      </div>

      <info-item
        label="Closed Date"
        :value="sellingInfo.closing_at"
        is-date
      ></info-item>
    </template>

    <!-- Expanded
    -------------------------------------------------- -->
    <template v-else>
      <h5 class="selling_status">Status <span>{{ sellingStatus }}</span></h5>
      <hr>

      <!-- Amounts -->
      <div> <!-- Need this div to allow css last-of-type to work -->
        <analysis-item
          label="Joint Venture Costs"
          :value="sellingInfo.joint_venture_costs"
        />
        <analysis-item
          label="Closing Costs"
          :value="sellingInfo.closing_costs"
        />
        <analysis-item
          label="Realtor Commissions"
          :value="sellingInfo.realtor_commissions"
        />
        <analysis-item
          label="Marketing Costs"
          :value="sellingInfo.marketing_costs"
        />
        <analysis-item
          label="Carrying Costs"
          :value="sellingInfo.carrying_costs"
        />
        <analysis-item
          label="Buyer Concessions"
          :value="sellingInfo.buyer_concessions"
        />
        <analysis-item
          label="Miscellaneous Fees"
          :value="sellingInfo.miscellaneous_fees"
        />
        <analysis-item
          label="Sale Amount"
          :value="sellingInfo.sale_amount"
        />
      </div>
      <hr>

      <!-- Actual Profit -->
      <profit-item
        type="Actual"
        :amount="record.actual_profit"
        hint="Actual Profit = Sale Amount - All Costs - Latest Buying Offer"
      ></profit-item>
      <hr>

      <!-- Dates -->
      <info-heading heading="Dates"></info-heading>
      <info-item
        label="Accepted Date"
        :value="sellingInfo.accepted_at"
        is-date
      ></info-item>
      <info-item
        label="Contract Date"
        :value="sellingInfo.contracted_at"
        is-date
      ></info-item>
      <info-item
        label="Closed Date"
        :value="sellingInfo.closing_at"
        is-date
      ></info-item>
    </template>
  </div>
</template>

<script>
import SummaryItem from "./SummaryItem";
import InfoItem from "./InfoItem";
import {ENUMS} from "../../../services/enums";
import AnalysisItem from "./AnalysisItem";
import ProfitItem from "./ProfitItem";
import InfoHeading from "./InfoHeading";

export default {
  name: "SellingInfoFlip",
  components: {
    InfoHeading,
    ProfitItem,
    AnalysisItem,
    InfoItem,
    SummaryItem
  },
  props: {
    sellingInfo: {
      type: Object,
      required: true
    },
    isSummary: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    record() {
      return this.$store.state.activeRecord.record;
    },
    sellingStatus() {
      if(this.sellingInfo.status) {
        return this.$utils.newGetEnumLabel(this.sellingInfo.status, ENUMS.FixAndFlipSellingInfoStatusEnum);
      }

      return '--'
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

hr {
  margin: 0.75rem (-$modalGutter);
}

.selling_status {
  margin-top: 8px;
  font-weight: bold;

  span {
    float: right;
  }
}
</style>
